import { Button, Grid, Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmDialog from "../../../shared/components/ConfirmDialog";
import { Routing } from "../../../shared/constants/routing";
import { rowsPerPageJsonData } from "../../../utils/JsonData";
import {
  deleteRecord,
  fetchList,
} from "../../../apis/services/CommonApiService";
import { ApiEndPoints } from "../../../apis/ApiEndPoints";
import { deleteVendorApiCall } from "../../../apis/services/VendorApiService";
import Loader from "../../../layout/Loader";
import { useTranslation } from "react-i18next";
import { getLanguageCode, getPermissionList } from "../../../utils/helper";
import { discountedRateDataGridOptionsSuccess } from "../../../Reducer/roomRateTabSlice";

export const DiscountedRate = (props) => {
  const {DiscountedRateDataGridOptions, datagridOptionsSucces} = props
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();



  const getvendorList = useCallback(async () => {
    if (DiscountedRateDataGridOptions?.rows?.length === 0) {
    updatevendorsDataGridOptions("loading", true);
    }
    const result = await fetchList(
      ApiEndPoints.GET_ROOM_RATES_DISCOUNT_RATE +
        `?page_no=${DiscountedRateDataGridOptions.page}&items_per_page=${DiscountedRateDataGridOptions.pageSize}`
    );
    if (result?.status === 200) {
      updatevendorsDataGridOptions("rows", result.data.rows);
      updatevendorsDataGridOptions("totalRows", result.data.totalRows);
      updatevendorsDataGridOptions("loading", false);
    } else {
      updatevendorsDataGridOptions("rows", []);
      updatevendorsDataGridOptions("totalRows", 0);
      updatevendorsDataGridOptions("loading", false);
    }
  }, [
    DiscountedRateDataGridOptions.page,
    DiscountedRateDataGridOptions.pageSize,
  ]);


  useEffect(() => {
    // getRoomRateDetail();
    getvendorList();
  }, [getvendorList]);

  const updatevendorsDataGridOptions = (k, v) =>
     datagridOptionsSucces({ key: k, value: v });


  const deletDiscountedRate = React.useCallback(
    (id) => () => {
      setDeletevendorId(id);
      setOpenDeletevendorDialog(true);
    },
    []
  );

  const editDiscountedRate = React.useCallback(
    (id) => () => {
      // console.log(id, "sdsfdsf");
      navigate(`/discounted-rate/edit/${id}`);
    },
    []
  );

  const AddDiscountedRate = React.useCallback(
    (id) => () => {
      navigate(`/discounted-rate/new/${id}`);
    },
    []
  );
  //delete room type api
  const [loading, setLoading] = React.useState(false);
  const [openDeletevendorDialog, setOpenDeletevendorDialog] =
    React.useState(false);
  const handleCloseDeleteRoomTypeDialog = () =>
    setOpenDeletevendorDialog(false);
  const [deletevendorId, setDeletevendorId] = useState(0);
  const handleConfirmDeleteVendorAction = async () => {
    setLoading(true);
    setOpenDeletevendorDialog(false);
    const result = await deleteRecord(
      deletevendorId,
      ApiEndPoints.ROOM_RATES_RESOURCE_ROUTE + `/delete-discounted-rate`
    );
    // const result = await deleteVendorApiCall(deletevendorId);
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getvendorList();
    } else if (result === undefined) {
      setLoading(false);
      toast.error(t(result.message));
    } else {
      setLoading(false);
      toast.error(t(result.message));
    }
  };
  const roomTypesDatagridColumns = [
    { field: "code", headerName: t("Code"), flex: 1 },
    { field: "name", headerName: t("Name"), flex: 1 },
    { field: "percentage", headerName: t("Percentage"), flex: 1 },
    {
      field: "actions",
      type: "actions",
      flex: 1,
      getActions: (params) => {
              const actions = [];
      
              // Check permission for "Edit"
              if (getPermissionList("Discounted Rate", 3)?.hasPermission) {
                actions.push(
                  <GridActionsCellItem
                    label={t("Edit")}
                    onClick={editDiscountedRate(params.id)}
                    showInMenu
                  />
                );
              }
      
              if (getPermissionList("Discounted Rate", 4)?.hasPermission) {
                actions.push(
                  <GridActionsCellItem
                  label={t("Delete")}
                  onClick={deletDiscountedRate(params.id)}
                  showInMenu
                  />
                );
              }
      
              return actions;
            },
    },
  ];
  return (
    <div className="main-layout-background h-100vh w-100">
      {loading && <Loader />}
     

      <div className="w-100 ">
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          style={{ marginLeft: "10px", marginBottom: "10px" }}
        >
          
        </Grid>
        <div style={{ width: "100%" }}>
          <DataGrid
            localeText={
              getLanguageCode().components.MuiDataGrid.defaultProps.localeText
            }
            density="compact"
            autoHeight
            getRowHeight={() => "auto"}
            pagination
            paginationMode="server"
            loading={DiscountedRateDataGridOptions.loading}
            rowCount={DiscountedRateDataGridOptions.totalRows}
            rowsPerPageOptions={
              DiscountedRateDataGridOptions.rowsPerPageOptions
            }
            // rows={ratesDatagridRows}
            rows={DiscountedRateDataGridOptions.rows}
            columns={roomTypesDatagridColumns}
            page={DiscountedRateDataGridOptions.page - 1}
            pageSize={DiscountedRateDataGridOptions.pageSize}
            checkboxSelection={true}
            onPageChange={(newPage) => {
              updatevendorsDataGridOptions("page", newPage + 1);
            }}
            onPageSizeChange={(pageSize) => {
              console.log("page size", pageSize);
              updatevendorsDataGridOptions("page", 1);
              updatevendorsDataGridOptions("pageSize", pageSize);
            }}
          />
        </div>
      </div>

      {/* Delete Room Category Alert */}
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you really want to Discounted Rate?")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("Delete")}
        openDialog={openDeletevendorDialog}
        handleDialogClose={handleCloseDeleteRoomTypeDialog}
        handleDialogAction={handleConfirmDeleteVendorAction}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
return {
  DiscountedRateDataGridOptions: state.roomRateTab.discountedRateDataGridOptions,
}
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    datagridOptionsSucces: (data) => dispatch(discountedRateDataGridOptionsSuccess(data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountedRate);
